import React from "react";
import { string } from "prop-types";

import { AdSlot, AdFree } from "../../rows/ad-free";

import "./sticky-banner.m.css";

const StickyBanner = () => {
  return (
    <AdFree>
      <div styleName="wrapper">
        <div styleName="banner mobile">
          <AdSlot id="stickey" type="mobile" />
        </div>
        <div styleName="banner desktop">
          <AdSlot id="stickey" type="desktop" />
        </div>
      </div>
    </AdFree>
  );
};

StickyBanner.propTypes = {
  pageType: string,
};

export default StickyBanner;
